import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import { ApiBaseQuery, ApiTagTypes } from '../types';
import { IS_DEV_MODE } from '../constants';
import { Room, TimeSlot, GetSlotsParams, CreateBookingRequest, Booking } from './types';

/**
 * Моковые данные для бронирований
 */
const getMockBookings = (): Booking[] => {
    return [
        {
            id: 1,
            room_name: 'Conference Room 1',
            room_image_links: ['/meeting1.jpg'],
            room_id: 1,
            room_description: 'Conference Room 1',
            booking_date: '2025-01-15',
            start_time: '10:00',
            end_time: '11:30',
            status: 'confirmed',
        },
        {
            id: 2,
            room_name: 'Conference Room 2',
            room_image_links: ['/meeting2.jpg'],
            room_id: 2,
            room_description: 'Conference Room 2',
            booking_date: '2025-01-16',
            start_time: '14:00',
            end_time: '16:00',
            status: 'confirmed',
        },
    ];
};

/**
 * Endpoints для работы с переговорными комнатами
 */
export const roomsEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    /**
     * Получение списка переговорных комнат
     */
    getRooms: builder.query<Room[], void>({
        query: () => ({
            url: '/private/rooms',
        }),
    }),
    /**
     * Получение слотов времени для бронирования
     */
    getRoomSlots: builder.query<TimeSlot[], GetSlotsParams>({
        query: ({ roomId, date }) => ({
            url: `/private/rooms/slots`,
            params: {
                room_id: roomId,
                date: date,
            },
        }),
        providesTags: ['Rooms'],
    }),
    /**
     * Создание бронирования переговорной комнаты
     */
    createBooking: builder.mutation<void, CreateBookingRequest>({
        query: (body) => ({
            url: '/private/bookings',
            method: 'POST',
            body,
        }),
        invalidatesTags: ['Rooms', 'Customer'],
    }),
    /**
     * Получение списка бронирований пользователя
     */
    getBookings: builder.query<Booking[], void>({
        query: () => ({
            url: '/private/bookings',
        }),
        providesTags: ['Rooms'],
    }),
});
